import React from 'react';
import Link from '@mui/material/Link';
import Logo from './Logo';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Typography, Grid, Box, Divider, Stack } from '@mui/material';
import { SoundCloudIcon } from '../customIcons/SoundCloudIcon';

// eslint-disable-next-line react/prop-types
const SocialLink = ({ href, icon: Icon }) => (
  <a
    className="social-redirect"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Icon color="primary" />
  </a>
);

const FooterDivider = () => (
  <Divider
    orientation="vertical"
    flexItem
    sx={{
      height: '100%',
      margin: '0 16px',
      borderColor: '#deff7b',
    }}
  />
);

// eslint-disable-next-line react/prop-types
const FooterLink = ({ href, children }) => (
  <Link href={href} underline="hover" color="text.secondary">
    {children}
  </Link>
);

const Footer = () => {
  const year = new Date().getFullYear();

  const socialLinks = [
    {
      href: 'https://www.instagram.com/kip.audio',
      icon: InstagramIcon,
    },
    {
      href: 'https://www.soundcloud.com/kip-audio',
      icon: SoundCloudIcon,
    },
  ];

  const footerLinks = [
    { href: '/about', label: 'About' },
    { href: '/policy', label: 'Privacy Policy' },
    { href: '/terms', label: 'Terms' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        textAlign: 'center',
        padding: '50px 0',
        position: 'relative',
        marginBottom: '70px',
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', md: '50%' },
          margin: 'auto',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '40px',
                height: '35px',
              }}
            >
              <Link href="/" underline="none">
                <Logo size={28} className={'logo2'} />
              </Link>
              <FooterDivider />
              <Stack direction="row" spacing={2}>
                {socialLinks.map((link) => (
                  <SocialLink key={link.href} {...link} />
                ))}
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              KIP democratizes access to electronic music producers, enabling
              new talent to be discovered, and advocating the enjoyment of
              musical journeys for all.
            </Typography>
          </Grid>

          <Stack
            sx={{ textAlign: 'center', width: '100%', mt: '12px' }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="body2" color="text.secondary">
              © {year} KIP
            </Typography>
            <FooterDivider />
            {footerLinks.map((link, index) => (
              <React.Fragment key={link.href}>
                <FooterLink href={link.href}>{link.label}</FooterLink>
                {index < footerLinks.length - 1 && <FooterDivider />}
              </React.Fragment>
            ))}
          </Stack>
        </Grid>
      </Box>
    </Box>
  );
};

export default Footer;
